
import { Button, ButtonProps, CircularProgress, SxProps, Theme } from "@mui/material";
import React from "react";
import classes from './ws-button.module.scss';


export interface WSButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
    onClick?: () => void;
    showloader?: boolean | number | undefined;
    disabled?: boolean;
    style?: React.CSSProperties;
    target?: string;
    children?: React.ReactNode;
    sx?: SxProps<Theme>;
}

export interface WSButtonState {

}

const WSButton = ({type, target, href, sx, showloader, onClick, disabled, children, ...rest}: WSButtonProps) => {
    return (<Button
        {...rest}
        {...(href ? { href, target } : {})}
        type={type ?? "button"}
        className={classes.button}
        color="primary"
        disabled={(!!showloader || disabled) ?? false}
        onClick={onClick}
        sx={sx}>
        {children}
        {!!showloader && <CircularProgress size={24} style={{ color: 'white' }} />}
    </Button>);
}

export default WSButton;